import { ReactComponent as GraphArrowIncrease } from "assets/svg/graph-arrow-increase.svg";
import { ReactComponent as GraphArrowDecrease } from "assets/svg/graph-arrow-decrease.svg";

import { NullableNumber, ReportEdgeItem, ReportItemSummaryType } from "types/Reports";
import { REPORT_SENSOR_REGISTRY } from "constant/report";

import {
    getEdgeCountUnit,
    getEdgeUsedFragment,
    getEdgeWithClause,
    getHighestOrLowestDayDisplay,
} from "./utils/reportString";
import { formatValueAndUnitBasedOnTypeInReport } from "./utils/reportFormat";

type ReportOUCEdgeTextProps = {
    isHighest: boolean;
    dateFormat: string;
    numberOfItems: NullableNumber;
    item: ReportEdgeItem;
    itemType: ReportItemSummaryType;
    unit: string;
};

// The full name should be Report Overall Usage Card Edge Text
export default function ReportOUCEdgeText({
    isHighest,
    dateFormat,
    numberOfItems,
    item,
    itemType,
    unit,
}: Readonly<ReportOUCEdgeTextProps>) {
    const edgeText = isHighest ? 'highest' : 'lowest';
    const typeText = REPORT_SENSOR_REGISTRY[itemType].edgeSubject;
    const numberItemDescription = getEdgeCountUnit(itemType, numberOfItems);
    const usedFragment = getEdgeUsedFragment(itemType);
    const usedText = usedFragment ? ` ${usedFragment}` : '';
    const withText = itemType === 'waterLeakage' ? ` ${getEdgeWithClause(itemType)} ` : ', with ';

    const valueDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, item.value, unit, true);

    const acrossText = `across ${numberOfItems} ${numberItemDescription}.*`;

    return <section className="report-edge-text mt-2">
        { isHighest ? <GraphArrowIncrease width="16px" height="16px" /> : <GraphArrowDecrease width="16px" height="16px" />}
        <p>
            {`The ${edgeText} ${typeText} was on `}
            <span className="report-edge-text-hl">{`${getHighestOrLowestDayDisplay(item.dates, dateFormat)}`}</span>
            {withText}
            <span className="report-edge-text-hl">{`${valueDisplay}`}</span>
            {`${usedText} ${acrossText}`}
        </p>
    </section>;
}
